import {
  updateColumnHighlight,
  sliderMinPrice,
  sliderMaxPrice,
  textFieldMinPrice,
  textFieldMaxPrice,
  searchMinPrice,
  searchMaxPrice,
  currencyStyle
} from './priceRange';
import { getElement } from '../../../common/asyncElementGetter';

const filterModalsEvents = async(document) => {
  const clearModalFiltersTriggers = document.querySelectorAll('.clear-modal-filters-btn');
  const checkboxFiltersElements = document.querySelectorAll('#modalFilters .modal-form-check');
  const checkboxElements = document.querySelectorAll('.modal-form-check');
  const checkboxAreasElements = document.querySelectorAll('#modalAreas .modal-form-check');
  const bedroomsCheckboxesParent = document.getElementById('bedrooms_checkbox_wrapper');
  const bathroomsCheckboxesParent = document.getElementById('bathrooms_checkbox_wrapper');
  const facilitiesCheckboxesParent = document.getElementById('facilities_checkbox_wrapper');
  const bedTypeCheckboxesParent = document.getElementById('bedtype_checkbox_wrapper');
  const bedroomsCheckboxes = bedroomsCheckboxesParent.querySelectorAll('input[type=checkbox]');
  const bathroomsCheckboxes = bathroomsCheckboxesParent.querySelectorAll('input[type=checkbox]');
  const facilitiesCheckboxes = facilitiesCheckboxesParent.querySelectorAll('input[type=checkbox]');
  const bedTypeCheckboxes = bedTypeCheckboxesParent.querySelectorAll('input[type=checkbox]');
  const searchInputs = document.querySelectorAll('.input-tabas');
  const clearModalAreaButton = document.querySelectorAll('.clear-modal-area-btn');
  const areaCheckboxesParent = document.getElementById('neighborhoods_checkbox_wrapper');
  const areaTypeCheckboxes = areaCheckboxesParent.querySelectorAll('input[type=checkbox]');
  const filtersButton = await getElement('#filters_button', false, true, 500, 30);

  const changeLabelOpacity = (element, checkOpen = false) => {
    const div = checkOpen ? element : element.target.parentElement;
    const checkbox = div.querySelector('.form-check-input');
    const label = div.querySelector('.form-check-label');
    if (checkbox.checked) {
      label.style.opacity = 1;
    } else {
      label.style.opacity = 0.5;
    }
  };

  const showSelectedFilter = () => {
    const bedroomWrapperParent = document.getElementById('bedrooms_checkbox_wrapper');
    const bedroomWrapper = bedroomWrapperParent.querySelectorAll('input[type=checkbox]');
    const bathroomWrapperParent = document.getElementById('bathrooms_checkbox_wrapper');
    const bathroomWrapper = bathroomWrapperParent.querySelectorAll('input[type=checkbox]');
    const facilityWrapperParent = document.getElementById('facilities_checkbox_wrapper');
    const facilityWrapper = facilityWrapperParent.querySelectorAll('input[type=checkbox]');
    const bedtypeWrapperParent = document.getElementById('bedtype_checkbox_wrapper');
    const bedtypeWrapper = bedtypeWrapperParent.querySelectorAll('input[type=checkbox]');
    const bedroomAccordion = document.getElementById('bedrooms_accordion');
    const bathroomAccordion = document.getElementById('bathrooms_accordion');
    const facilityAccordion = document.getElementById('amenities_accordion');
    const bedtypeAccordion = document.getElementById('bedtype_accordion');

    bedroomWrapperParent.classList.remove('show');
    bathroomWrapperParent.classList.remove('show');
    facilityWrapperParent.classList.remove('show');
    bedtypeWrapperParent.classList.remove('show');
    bedroomAccordion.classList.add('collapsed');
    facilityAccordion.classList.add('collapsed');
    bedtypeAccordion.classList.add('collapsed');

    facilityAccordion.addEventListener('click', () => {
      setTimeout(() => {
        facilityAccordion.scrollIntoView({ behavior: 'smooth' });
      }, 220);
    });

    bedtypeAccordion.addEventListener('click', () => {
      setTimeout(() => {
        bedtypeAccordion.scrollIntoView({ behavior: 'smooth' });
      }, 220);
    });

    if (Array.from(bedroomWrapper).some(bedroom => bedroom.checked)) {
      bedroomWrapperParent.classList.add('show');
      bedroomAccordion.classList.remove('collapsed');
    }
    if (Array.from(bathroomWrapper).some(bathroom => bathroom.checked)) {
      bathroomWrapperParent.classList.add('show');
      bathroomAccordion.classList.remove('collapsed');
    }
    if (Array.from(facilityWrapper).some(facility => facility.checked)) {
      facilityWrapperParent.classList.add('show');
      facilityAccordion.classList.remove('collapsed');
    }
    if (Array.from(bedtypeWrapper).some(bedtype => bedtype.checked)) {
      bedtypeWrapperParent.classList.add('show');
      bedtypeAccordion.classList.remove('collapsed');
    }
    checkboxFiltersElements.forEach((element) => { changeLabelOpacity(element, true) });
  };

  const clearModalFilters = () => {
    [...bedroomsCheckboxes, ...bathroomsCheckboxes, ...facilitiesCheckboxes, ...bedTypeCheckboxes].forEach(el => { el.checked = false });
    searchInputs.forEach((input) => { input.value = '' });

    sliderMinPrice.value = sliderMinPrice.min;
    textFieldMinPrice.value = currencyStyle(sliderMinPrice.min);
    searchMinPrice.value = null;

    sliderMaxPrice.value = sliderMaxPrice.max;
    textFieldMaxPrice.value = currencyStyle(sliderMaxPrice.max);
    searchMaxPrice.value = null;

    updateColumnHighlight();
    checkboxFiltersElements.forEach((element) => { changeLabelOpacity(element, true) });
  };

  const clearAreaFilters = () => {
    [...areaTypeCheckboxes].forEach(el => { el.checked = false });
    checkboxAreasElements.forEach((element) => { changeLabelOpacity(element, true) });
  };

  clearModalFiltersTriggers.forEach(el => el.addEventListener('click', clearModalFilters));
  clearModalAreaButton.forEach(el => el.addEventListener('click', clearAreaFilters));
  checkboxElements.forEach(el => el.addEventListener('click', event => (changeLabelOpacity(event))));
  filtersButton.addEventListener('click', showSelectedFilter);
  document.getElementById('areas_button').addEventListener('click', () => { checkboxAreasElements.forEach((element) => { changeLabelOpacity(element, true) }) });
};

export default filterModalsEvents;
